<template>
    <div v-if="$route.meta.isBreadcrumb == true" class="biz-breadcrumb">
        <ul>
            <li
            v-for="(breadcrumb, idx) in breadcrumbList"
            :key="idx"
            @click="routeTo(idx)"
            :class="{'linked': !!breadcrumb.link}">
                {{ breadcrumb.name }}
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data () {
        return {
            breadcrumbList: []
        }
    },
    mounted () { 
        this.updateList() 
        console.log(this.$route.meta.isBreadcrumb)
    },
    watch: { 
        '$route' () { 
            this.updateList() 
        } 
    },
    methods: {
        routeTo (pRouteTo) {
            if (this.breadcrumbList[pRouteTo].link) this.$router.push({name: this.breadcrumbList[pRouteTo].link})
        },
        updateList () { 
            this.breadcrumbList = this.$route.meta.breadcrumb 
        }
    }
}
</script>
<style   lang="scss">
    .biz-breadcrumb {
        background: #fff;
        margin-top: 70px;
        padding: 11px 0 11px 30px;
        border-top: solid 1px #f3f3f3;
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        ul {
            display: flex;
            list-style: none;
            padding: 0;
            li {
                font-size: 12px;
                font-weight: 300;
                color: #a8a5a4;
                &.linked{
                    cursor: pointer;
                }
                &:last-child {
                    cursor: default;
                    color: #525956;
                }
                &:not(:last-child):after {
                    content: "/";
                    margin-left: 5px;
                    margin-right: 10px;
                }
            }
        }
    }
    

</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/bizBreadcrumb.vue